export default __webpack_public_path__ + "static/media/tour-2.b18370f4.png";